const featureSettings = {
    enable_config_template: false,
};

export { featureSettings };
